import { render } from "./CategorySlide.vue?vue&type=template&id=058a51f6&lang=pug"
import script from "./CategorySlide.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySlide.vue?vue&type=script&setup=true&lang=js"

import "./CategorySlide.vue?vue&type=style&index=0&id=058a51f6&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__